import { useEffect, useState } from "react";
import { clearCachedAccessStatus } from "./accessStatusCache";
import { resetSurveyNonMicPermissions } from "./surveyPermissionGate";

const UNLOCK_KEY = "dople_survey_entry_unlocked_v1";
const COMPLETION_KEY = "dople_onboarding_completion";
const ENTRY_EVENT = "dople:survey-entry";

const readCompletion = () => {
  try {
    return window.localStorage.getItem(COMPLETION_KEY) === "complete";
  } catch {
    return false;
  }
};

export function isSurveyEntryUnlocked() {
  try {
    return window.localStorage.getItem(UNLOCK_KEY) === "1";
  } catch {
    return false;
  }
}

export function markSurveyEntryUnlocked() {
  try {
    window.localStorage.setItem(UNLOCK_KEY, "1");
  } catch {
    // Navigation still works if storage is unavailable.
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(ENTRY_EVENT));
  }
}

export function clearSurveyRoutingCache() {
  try {
    window.localStorage.removeItem(UNLOCK_KEY);
    window.localStorage.removeItem(COMPLETION_KEY);
  } catch {
    // Best-effort session cleanup.
  }
  resetSurveyNonMicPermissions();
  clearCachedAccessStatus();
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(ENTRY_EVENT));
  }
}

// Competing app links stay hidden until the interview has started or the
// account already finished onboarding. Logout is not one of those links.
export function competingAppNavLocked(isAuthenticated) {
  if (!isAuthenticated) return false;
  if (readCompletion()) return false;
  if (isSurveyEntryUnlocked()) return false;
  return true;
}

export function useCompetingAppNavLocked(isAuthenticated) {
  const [locked, setLocked] = useState(() => competingAppNavLocked(isAuthenticated));
  useEffect(() => {
    const sync = () => setLocked(competingAppNavLocked(isAuthenticated));
    sync();
    window.addEventListener(ENTRY_EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(ENTRY_EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, [isAuthenticated]);
  return locked;
}
